import { StandardEvents } from '@shopify/events';
let refreshController;
let refreshVersion = 0;
let hideTimer;

async function refreshCartCount() {
  const link = document.querySelector('[data-hoxo-cart-link]');
  if (!link) return;
  const version = ++refreshVersion;
  refreshController?.abort();
  refreshController = new AbortController();
  const url = new URL(link.href);
  url.pathname = `${url.pathname.replace(/\/$/, '')}.js`;
  try {
    const response = await fetch(url, {
      headers: { Accept: 'application/json' },
      cache: 'no-store',
      signal: refreshController.signal,
    });
    if (!response.ok) return;
    const cart = await response.json();
    if (version !== refreshVersion || !Number.isInteger(cart.item_count) || cart.item_count < 0) return;
    for (const count of document.querySelectorAll('[data-hoxo-cart-count]')) {
      count.textContent = String(cart.item_count);
    }
  } catch {}
}

function hideFeedback() {
  clearTimeout(hideTimer);
  for (const feedback of document.querySelectorAll('[data-hoxo-cart-feedback]')) feedback.hidden = true;
}

document.addEventListener(StandardEvents.cartLinesUpdate, async (event) => {
  if (!event.promise) return;
  try {
    const result = await event.promise;
    if (!result?.detail?.didError && result?.detail?.source === 'product-form-component') {
      const feedback = document.querySelector('[data-hoxo-cart-feedback]');
      if (feedback) {
        clearTimeout(hideTimer);
        feedback.hidden = false;
        hideTimer = setTimeout(hideFeedback, 8000);
      }
    }
    const itemCount = result?.cart?.totalQuantity;
    if (Number.isInteger(itemCount) && itemCount >= 0) {
      ++refreshVersion;
      refreshController?.abort();
      for (const count of document.querySelectorAll('[data-hoxo-cart-count]')) {
        count.textContent = String(itemCount);
      }
      return;
    }
  } catch {}
  await refreshCartCount();
});

document.addEventListener('click', (event) => {
  if (event.target instanceof Element && event.target.closest('[data-hoxo-cart-dismiss]')) hideFeedback();
});

window.addEventListener('pageshow', (event) => {
  if (event.persisted) refreshCartCount();
});

document.addEventListener('shopify:section:load', refreshCartCount);
window.addEventListener('pagehide', () => {
  ++refreshVersion;
  refreshController?.abort();
  hideFeedback();
});

